import type { Team } from "../api/types";

interface Props {
  teams: Team[];
  selectedId: string | null;
  onChange: (id: string) => void;
  label?: string;
}

export function TeamPicker({ teams, selectedId, onChange, label = "Team" }: Props) {
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      <select value={selectedId ?? ""} onChange={(e) => onChange(e.target.value)}>
        {teams.map((team) => (
          <option key={team.id} value={team.id}>
            {team.name}
          </option>
        ))}
      </select>
    </label>
  );
}
